import { BuilderType, projectsCacheTags } from './projectsApiHelpers';

export const projectStatsApi = (builder: BuilderType) => ({
  getTopClients: builder.query<any, void>({
    query: (top) => `service/project/stats/top-clients?top=${top}`,
    providesTags: [projectsCacheTags.PROJECTS],
  }),
});
